module.exports = __webpack_public_path__ + "img/about_banner3.20320286.jpg";